import { ITableDataSetSection, TableDataSetSection } from './TableDataSetSection';
import { IDataSet } from '@/models/dataset/DataSet';
import { IConfiguration } from '@/models/configuration/Configuration';
import { TableDataSetActionFieldCount } from './TableDataSetActionFieldCount';
import { DataSetEditor } from '@/models/dataset/DataSetEditor';
import { DataSetMyMillInformation, IDataSetMyMillInformation } from '../dataset/DataSetMyMillInformation';

export interface ITableDataSet {
    id?: number;
    dataSetId?: string;
    sections: ITableDataSetSection[];

    created: DataSetEditor;
    lastModified?: DataSetEditor;
    myMillImport?: IDataSetMyMillInformation;

    actionItems?: TableDataSetActionFieldCount[];

    unsyncedParts?: boolean;
    fixedRow?: boolean;
}

export class TableDataSet implements ITableDataSet {
    public id?: number;
    public dataSetId?: string;
    public sections: TableDataSetSection[];


    public created: DataSetEditor;
    public lastModified?: DataSetEditor;
    public myMillImport?: DataSetMyMillInformation;

    public actionItems?: TableDataSetActionFieldCount[];

    public unsyncedParts?: boolean;
    public fixedRow?: boolean;

    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: ITableDataSet);
    // tslint:disable-next-line: unified-signatures
    constructor(obj: IConfiguration);
    // tslint:disable-next-line: unified-signatures
    constructor(obj: IDataSet);
    constructor(obj?: any) {
        // do not set id to undefined or dexie.js will throw an error
        if (obj && obj.id != null) {
            this.id = obj.id;
        }

        this.dataSetId = obj && obj.dataSetId != null ? obj.dataSetId : undefined;
        this.unsyncedParts = obj && obj.unsyncedParts || false;
        this.fixedRow = obj && obj.fixedRow || false;

        this.sections = [];
        if (obj && obj.sections !== undefined) {
            obj.sections.forEach((section: any) => {
                this.sections.push(new TableDataSetSection(section));
            });
        }

        if (obj && obj.actionItems !== undefined) {
            this.actionItems = [];
            obj.actionItems.forEach((actionItem: any) => {
                if (this.actionItems !== undefined) {
                    this.actionItems.push(new TableDataSetActionFieldCount(actionItem));
                }
            });
        }

        if (obj && obj.created) {
            this.created = new DataSetEditor(obj.created);
        } else {
            this.created = new DataSetEditor();
        }

        if (obj && obj.lastModified) {
            this.lastModified = new DataSetEditor(obj.lastModified);
        }

        if (obj && obj.myMillImport) {
            this.myMillImport = new DataSetMyMillInformation(obj.myMillImport);
        }
    }
}
